import { machineTypesConstants } from './machineTypesConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  logItems: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  startDate: null,
  endDate: null,
  total: 0,
  logTotal: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function games_registry_machine_types(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case machineTypesConstants.MACHINE_TYPES_LIST_REQUEST:
    case machineTypesConstants.MACHINE_TYPES_LOAD_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        logTotal: 0,
        inProgress: true,
      };
    case machineTypesConstants.MACHINE_TYPES_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.machineTypes.rows ? action.machineTypes.rows : [],
        total: action.machineTypes.total ? action.machineTypes.total : 0,
        inProgress: false,
      };
    }
    case machineTypesConstants.MACHINE_TYPES_LOAD_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        logItems: action.machineTypes.rows ? action.machineTypes.rows : [],
        logTotal: action.machineTypes.total ? action.machineTypes.total : 0,
        inProgress: false,
      };
    }
    case machineTypesConstants.MACHINE_TYPES_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case machineTypesConstants.MACHINE_TYPES_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case machineTypesConstants.MACHINE_TYPES_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.startDate !== action.pagination.startDate
        || state.endDate !== action.pagination.endDate
        || state.exactValues !== action.pagination.exactValues
        || state.exactFields !== action.pagination.exactFields
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        exactValues: action.pagination.exactValues,
        exactFields: action.pagination.exactFields,
        shouldReload
      };
    }

    case machineTypesConstants.MACHINE_TYPES_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case machineTypesConstants.MACHINE_TYPES_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.machineTypes],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.machineTypes.id ? action.machineTypes : t)
      }
    case machineTypesConstants.MACHINE_TYPES_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }
    default:
      return state
  }
}
